// Utils
import editorIsOnly from '../../../customRichUtils/editorState/editorIsOnly';
import { isValidColorFormat } from '../../../../../../common/colors/colorSpaceUtil';

export default editorIsOnly(isValidColorFormat);
